import { render, staticRenderFns } from "./CollectedUsers.vue?vue&type=template&id=5d00c6e6&scoped=true&"
import script from "./CollectedUsers.vue?vue&type=script&lang=js&"
export * from "./CollectedUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d00c6e6",
  null
  
)

export default component.exports